import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { SEARCE_COLORS } from '../../../theme';
import { SKELETON_ANIMATION, skeletonTintSx } from './skeletonTokens';

export interface SectionSuspenseSkeletonProps {
  /** Shown above skeleton blocks */
  message?: string;
  /** Overall vertical padding */
  py?: number;
  minHeight?: number;
}

/**
 * Compact block for `React.Suspense` fallbacks inside the dashboard shell.
 */
export const SectionSuspenseSkeleton: React.FC<SectionSuspenseSkeletonProps> = ({
  message = 'Loading…',
  py = 4,
  minHeight = 200,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      justifyContent: 'center',
      py,
      px: 2,
      minHeight,
      gap: 2,
    }}
    role="status"
    aria-busy
    aria-label={message}
  >
    {message != null && message !== '' && (
      <Typography variant="body2" sx={{ color: SEARCE_COLORS.textSecondary, textAlign: 'center' }}>
        {message}
      </Typography>
    )}
    <Skeleton
      variant="text"
      animation={SKELETON_ANIMATION}
      width="50%"
      height={28}
      sx={{ mx: 'auto', ...skeletonTintSx }}
    />
    <Skeleton
      variant="rounded"
      animation={SKELETON_ANIMATION}
      height={120}
      sx={{ borderRadius: 1, ...skeletonTintSx }}
    />
    <Skeleton
      variant="rounded"
      animation={SKELETON_ANIMATION}
      height={80}
      sx={{ borderRadius: 1, ...skeletonTintSx }}
    />
  </Box>
);
